module.exports = __webpack_public_path__ + "df26f5b1c3c0fc83482e314dfc0b94a9.svg";